import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from '../fragments/COMPONENT_COLORS_AND_SIZES';
const SET_VARIANT_COLOR_FOR_ALL_SPECIFICATION_COLORS = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  mutation SetVariantColorForAllSpecificationColors(
    $componentId: ID!
    $productVariantColor: String!
  ) {
    setVariantColorForAllSpecificationColors(
      componentId: $componentId
      productVariantColor: $productVariantColor
    ) {
      component {
        id
        variantColorForAllSpecificationColors
        ...ComponentColorsAndSizesFragment
      }
    }
  }
`;
export default SET_VARIANT_COLOR_FOR_ALL_SPECIFICATION_COLORS;
